import { Route, Routes } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { UrlShortenerPage } from 'pages/settings/pages/urlShortener/ui/UrlShortenerPage/UrlShortenerPage'

export const UrlShortenerRouter = observer(() => {
  return (
    <Routes>
      <Route index element={<UrlShortenerPage />} />
    </Routes>
  )
})
